import React  from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box, Grid, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import EmailField from 'src/Patient/components/EmailField';
import useSavePatient from 'src/Patient/hooks/useSavePatient';
import ButtonCustom from 'src/shared/components/buttons/ButtonCustom';

const FormSendEmail = () => {

    const { handleClickSendEmail, loading } = useSavePatient()
    return (
        <div className='animate__animated animate__fadeIn'>
            <Typography variant="subtitle1" color="primary">
                Escriba su correo electrónico
            </Typography>
            <Grid container spacing={2} mt={2}>
                <Grid item md={12} xs={12}>
                    <EmailField onKeyEnter={handleClickSendEmail} />
                    <Typography variant="subtitle2" color={grey[400]} fontWeight={500} lineHeight={'15px'} fontSize={10} mt={1}>
                        Será necesario para recuperar su contraseña
                    </Typography>
                </Grid>
            </Grid>

            <Grid container display={"flex"} justifyContent={"center"} p={2} mt={1}>
                <Box>
                    <ButtonCustom
                        color="secondary"
                        loading={loading}
                        text="ENVIAR CLAVE TEMPORAL"
                        icon={<NavigateNextIcon />}
                        onClick={handleClickSendEmail}
                    />
                </Box>

            </Grid>
        </div>
    )
}

export default FormSendEmail;